module.exports = __webpack_public_path__ + "img/123.5cc0d7a7.jpg";